import { useContext } from 'react'
import { DataContext } from '../context/DataContext'

export default function () {
  return useContext(DataContext)
}
